import GoogleAnalyticsLog from '@loggi/analytics';

export default function sendGoogleAnalyticsDataEvent(event) {
  const NOTIFICATION_DESCRIPTION = 'notificationSubscription';

  const eventCategory = event.categoryName || NOTIFICATION_DESCRIPTION;
  if (event.action) {
    const logData = {
      eventCategory,
      eventAction: event.action
    };

    if (event.label) {
      logData.eventLabel = event.label;
    }

    if (event.value) {
      logData.eventValue = event.value;
    }

    return GoogleAnalyticsLog(logData);
  }

  throw new Error(
    '[Package Tracker Analytics]: Missing google analytics event action'
  );
}
